import React from "react";
import styled from "styled-components";

const Header = styled.header`
  padding: 0 1.5rem;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 2.5rem;
  font-weight: normal;
  color: #848484;

  @media (min-width: 640px) {
    font-size: 3.5rem;
  }
`;

const QuizHeader = ({ name }) => (
  <Header>
    <Title>{name}</Title>
  </Header>
);

export default QuizHeader;
